import { FC } from 'react';
import { IonButton } from '@ionic/react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { RecordingState } from '../recording/RecordingState';

export const SimulateRecordingButton: FC = () => {
    const recordingState = useInstance(RecordingState);

    const handleClick = () => {
        recordingState.simulateRecordingSuccess();
    };

    return (
        <IonButton
            fill="outline"
            color="secondary"
            size="small"
            onClick={handleClick}
            data-id="simulate-recording-success"
            style={{ marginLeft: '8px' }}
        >
            Simulate Success
        </IonButton>
    );
};
